import APIClient from '../../../common/APIClient';
import { displayError } from '../commonActions';

const FETCH_TASKS = 'FETCH_TASKS';
const ADD_TASKS_TO_PROJECT = 'ADD_TASKS_TO_PROJECT';
const RESET_TASKS_TO_PROJECT = 'RESET_TASKS_TO_PROJECT';
const SET_TASK_SEARCH_KEYWORD = 'SET_TASK_SEARCH_KEYWORD';
const CLEAR_SEARCH_KEYWORD = 'CLEAR_SEARCH_KEYWORD';

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

export const addTasksToProject = (taskId, actionItem) => {
  return (dispatch) => {
    dispatch({type: ADD_TASKS_TO_PROJECT, taskId, actionItem});
  }
}

export const filterTasks = (keyword) => {
  return (dispatch) => {
    dispatch({type: SET_TASK_SEARCH_KEYWORD, keyword});
  }
}

export const clearFilter = () => {
  return (dispatch) => {
    dispatch({type: CLEAR_SEARCH_KEYWORD});
  }
}

export const resetTasksToProject = () => {
  return (dispatch) => {
    dispatch({type: RESET_TASKS_TO_PROJECT});
  }
}

export const fetchTasks = (filter = null) => {
  return (dispatch) => {
    client().get(
      '/tasks-template/activities/list', {
        params: filter
      }
    ).then(json => {
      const result = json.data;
        if (result) {
          const tasks = result.data;
          dispatch({type: FETCH_TASKS, tasks});
        }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}